var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isAppDataLoading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_vm._t("default"),_c('popup-stack'),_c('snack-bar')],2)}
var staticRenderFns = []

export { render, staticRenderFns }